import React from 'react';
import Column from '../Column';

const Row = ({ row, className, labels }) => (
    <div className={className}>
        {
            Object.keys(row).map((key, index) => (
                <Column
                    key={key}
                    html={row[key]}
                    label={labels && labels[index]}
                />
            ))
        }
    </div>
);

export default Row;